module.exports = __webpack_public_path__ + "39b406d6b66609086e990a194485323c.svg";